// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./../tolemac/pub/filter";
import * as dep_2 from "./user";
import * as dep_3 from "./packages";
import * as dep_4 from "./package_file";
import * as dep_5 from "./comment";
import * as dep_6 from "./contact";
import * as dep_7 from "./../google/protobuf/empty";
import * as dep_8 from "./../google/protobuf/wrappers";

export interface IContactTrainingAssignApi {
    assign?: IContactTrainingAssign;
    contact?: dep_6.IContact;
    training?: dep_3.IPackageTraining;

}
export class ContactTrainingAssignApi implements IContactTrainingAssignApi {

    assign?: ContactTrainingAssign;
    contact?: dep_6.Contact;
    training?: dep_3.PackageTraining;

    constructor(data?: Partial<IContactTrainingAssignApi>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactTrainingAssignApi extends Message implements ContactTrainingAssignApi {

    constructor(data?: Partial<IContactTrainingAssignApi>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("assign" in data && data.assign != undefined) this.assign = new MContactTrainingAssign(data.assign);
            if ("contact" in data && data.contact != undefined) this.contact = new dep_6.MContact(data.contact);
            if ("training" in data && data.training != undefined) this.training = new dep_3.MPackageTraining(data.training);
        }
    }

    get assign(): MContactTrainingAssign {
        return Message.getWrapperField(this, MContactTrainingAssign, 1);
    }
    set assign(value: MContactTrainingAssign) {
        Message.setWrapperField(this, 1, value);
    }

    get contact(): dep_6.MContact {
        return Message.getWrapperField(this, dep_6.MContact, 2);
    }
    set contact(value: dep_6.MContact) {
        Message.setWrapperField(this, 2, value);
    }

    get training(): dep_3.MPackageTraining {
        return Message.getWrapperField(this, dep_3.MPackageTraining, 3);
    }
    set training(value: dep_3.MPackageTraining) {
        Message.setWrapperField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactTrainingAssignApi() : {} as ContactTrainingAssignApi;
        if (this.assign != undefined) data.assign = this.assign.toObject(includeInstance);
        if (this.contact != undefined) data.contact = this.contact.toObject(includeInstance);
        if (this.training != undefined) data.training = this.training.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.assign !== undefined) writer.writeMessage(1, this.assign, () => this.assign.serialize(writer));
                if (this.contact !== undefined) writer.writeMessage(2, this.contact, () => this.contact.serialize(writer));
                if (this.training !== undefined) writer.writeMessage(3, this.training, () => this.training.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactTrainingAssignApi): Uint8Array {
        return (data instanceof Message ? (data as MContactTrainingAssignApi) : new MContactTrainingAssignApi(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactTrainingAssignApi {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactTrainingAssignApi();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.assign, () => message.assign = MContactTrainingAssign.deserialize(reader));
                    break;
            case 2:
                    reader.readMessage(message.contact, () => message.contact = dep_6.MContact.deserialize(reader));
                    break;
            case 3:
                    reader.readMessage(message.training, () => message.training = dep_3.MPackageTraining.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactTrainingAssignApi {
        return MContactTrainingAssignApi.deserializeBinaryFromReader(new MContactTrainingAssignApi(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactTrainingAssignApi, reader: BinaryReader) {
        return Object.assign(msg, MContactTrainingAssignApi.deserialize(reader))
    };

}
export interface IContactTrainingAssignsApi {
    values?: IContactTrainingAssignApi[];
    count?: number;

}
export class ContactTrainingAssignsApi implements IContactTrainingAssignsApi {

    values: ContactTrainingAssignApi[];
    count?: number;

    constructor(data?: Partial<IContactTrainingAssignsApi>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactTrainingAssignsApi extends Message implements ContactTrainingAssignsApi {

    constructor(data?: Partial<IContactTrainingAssignsApi>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MContactTrainingAssignApi(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MContactTrainingAssignApi[] {
        return Message.getRepeatedWrapperField(this, MContactTrainingAssignApi, 1);
    }
    set values(value: MContactTrainingAssignApi[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactTrainingAssignsApi() : {} as ContactTrainingAssignsApi;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactTrainingAssignsApi): Uint8Array {
        return (data instanceof Message ? (data as MContactTrainingAssignsApi) : new MContactTrainingAssignsApi(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactTrainingAssignsApi {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactTrainingAssignsApi();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MContactTrainingAssignApi.deserialize(reader), MContactTrainingAssignApi));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactTrainingAssignsApi {
        return MContactTrainingAssignsApi.deserializeBinaryFromReader(new MContactTrainingAssignsApi(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactTrainingAssignsApi, reader: BinaryReader) {
        return Object.assign(msg, MContactTrainingAssignsApi.deserialize(reader))
    };

}
export interface IContactPackage {
    id?: number;
    state?: IContactPackageState;
    /**
     * @lazy
     */
    trainings?: IContactTraining[];
    /**
     * @lazy (id by default)
     */
    package?: dep_3.IPackage;
    /**
     * @lazy
     */
    timespans?: dep_4.ITimespanPackage[];

}
export class ContactPackage implements IContactPackage {

    id?: number;
    state?: ContactPackageState;
    trainings?: ContactTraining[];
    package?: dep_3.Package;
    timespans?: dep_4.TimespanPackage[];

    constructor(data?: Partial<IContactPackage>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactPackage extends Message implements ContactPackage {

    constructor(data?: Partial<IContactPackage>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2,21], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("state" in data && data.state != undefined) this.state = new MContactPackageState(data.state);
            if ("trainings" in data && data.trainings != undefined) this.trainings = data.trainings.map(d => new MContactTraining(d));
            if ("package" in data && data.package != undefined) this.package = new dep_3.MPackage(data.package);
            if ("timespans" in data && data.timespans != undefined) this.timespans = data.timespans.map(d => new dep_4.MTimespanPackage(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get state(): MContactPackageState {
        return Message.getWrapperField(this, MContactPackageState, 3);
    }
    set state(value: MContactPackageState) {
        Message.setWrapperField(this, 3, value);
    }

    get trainings(): MContactTraining[] {
        return Message.getRepeatedWrapperField(this, MContactTraining, 2);
    }
    set trainings(value: MContactTraining[]) {
        Message.setRepeatedWrapperField(this, 2, value);
    }

    get package(): dep_3.MPackage {
        return Message.getWrapperField(this, dep_3.MPackage, 20);
    }
    set package(value: dep_3.MPackage) {
        Message.setWrapperField(this, 20, value);
    }

    get timespans(): dep_4.MTimespanPackage[] {
        return Message.getRepeatedWrapperField(this, dep_4.MTimespanPackage, 21);
    }
    set timespans(value: dep_4.MTimespanPackage[]) {
        Message.setRepeatedWrapperField(this, 21, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactPackage() : {} as ContactPackage;
        if (this.id != undefined) data.id = this.id;
        if (this.state != undefined) data.state = this.state.toObject(includeInstance);
        if (this.trainings.length) data.trainings = this.trainings.map(d => d.toObject(includeInstance));

        if (this.package != undefined) data.package = this.package.toObject(includeInstance);
        if (this.timespans.length) data.timespans = this.timespans.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.state !== undefined) writer.writeMessage(3, this.state, () => this.state.serialize(writer));
                if (this.trainings !== undefined) writer.writeRepeatedMessage(2, this.trainings, (i) => i.serialize(writer));
                if (this.package !== undefined) writer.writeMessage(20, this.package, () => this.package.serialize(writer));
                if (this.timespans !== undefined) writer.writeRepeatedMessage(21, this.timespans, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactPackage): Uint8Array {
        return (data instanceof Message ? (data as MContactPackage) : new MContactPackage(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactPackage {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactPackage();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 3:
                    reader.readMessage(message.state, () => message.state = MContactPackageState.deserialize(reader));
                    break;
            case 2:
                    reader.readMessage(message.trainings, () => Message.addToRepeatedWrapperField(message, 2, MContactTraining.deserialize(reader), MContactTraining));
                    break;
            case 20:
                    reader.readMessage(message.package, () => message.package = dep_3.MPackage.deserialize(reader));
                    break;
            case 21:
                    reader.readMessage(message.timespans, () => Message.addToRepeatedWrapperField(message, 21, dep_4.MTimespanPackage.deserialize(reader), dep_4.MTimespanPackage));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactPackage {
        return MContactPackage.deserializeBinaryFromReader(new MContactPackage(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactPackage, reader: BinaryReader) {
        return Object.assign(msg, MContactPackage.deserialize(reader))
    };

}
export interface IContactPackageState {
    /**
     * contact_package.contact_trainings.contact_training_modules.contact_sections.contact_assigns.status
     */
    assignsSubmitted?: number;
    /**
     * % - 0 > 1
     */
    completed?: number;
    /**
     * % - 0 > 1
     */
    theoCompleted?: number;
    /**
     * min(timespan_packages.start_at)
     */
    startAt?: number;
    /**
     * max(timespan_packages.end_at)
     */
    endAt?: number;
    status?: string;

}
export class ContactPackageState implements IContactPackageState {

    assignsSubmitted?: number;
    completed?: number;
    theoCompleted?: number;
    startAt?: number;
    endAt?: number;
    status?: string;

    constructor(data?: Partial<IContactPackageState>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactPackageState extends Message implements ContactPackageState {

    constructor(data?: Partial<IContactPackageState>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("assignsSubmitted" in data && data.assignsSubmitted != undefined) this.assignsSubmitted = data.assignsSubmitted;
            if ("completed" in data && data.completed != undefined) this.completed = data.completed;
            if ("theoCompleted" in data && data.theoCompleted != undefined) this.theoCompleted = data.theoCompleted;
            if ("startAt" in data && data.startAt != undefined) this.startAt = data.startAt;
            if ("endAt" in data && data.endAt != undefined) this.endAt = data.endAt;
            if ("status" in data && data.status != undefined) this.status = data.status;
        }
    }

    get assignsSubmitted(): number {
        return Message.getField(this, 2) as number;
    }
    set assignsSubmitted(value: number) {
        Message.setField(this, 2, value);
    }

    get completed(): number {
        return Message.getField(this, 3) as number;
    }
    set completed(value: number) {
        Message.setField(this, 3, value);
    }

    get theoCompleted(): number {
        return Message.getField(this, 4) as number;
    }
    set theoCompleted(value: number) {
        Message.setField(this, 4, value);
    }

    get startAt(): number {
        return Message.getField(this, 5) as number;
    }
    set startAt(value: number) {
        Message.setField(this, 5, value);
    }

    get endAt(): number {
        return Message.getField(this, 6) as number;
    }
    set endAt(value: number) {
        Message.setField(this, 6, value);
    }

    get status(): string {
        return Message.getField(this, 7) as string;
    }
    set status(value: string) {
        Message.setField(this, 7, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactPackageState() : {} as ContactPackageState;
        if (this.assignsSubmitted != undefined) data.assignsSubmitted = this.assignsSubmitted;
        if (this.completed != undefined) data.completed = this.completed;
        if (this.theoCompleted != undefined) data.theoCompleted = this.theoCompleted;
        if (this.startAt != undefined) data.startAt = this.startAt;
        if (this.endAt != undefined) data.endAt = this.endAt;
        if (this.status != undefined) data.status = this.status;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.assignsSubmitted !== undefined) writer.writeInt32(2, this.assignsSubmitted);
                if (this.completed !== undefined) writer.writeDouble(3, this.completed);
                if (this.theoCompleted !== undefined) writer.writeDouble(4, this.theoCompleted);
                if (this.startAt !== undefined) writer.writeInt64(5, this.startAt);
                if (this.endAt !== undefined) writer.writeInt64(6, this.endAt);
                if (this.status !== undefined) writer.writeString(7, this.status);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactPackageState): Uint8Array {
        return (data instanceof Message ? (data as MContactPackageState) : new MContactPackageState(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactPackageState {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactPackageState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 2:
                    message.assignsSubmitted = reader.readInt32();
                    break;
            case 3:
                    message.completed = reader.readDouble();
                    break;
            case 4:
                    message.theoCompleted = reader.readDouble();
                    break;
            case 5:
                    message.startAt = reader.readInt64();
                    break;
            case 6:
                    message.endAt = reader.readInt64();
                    break;
            case 7:
                    message.status = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactPackageState {
        return MContactPackageState.deserializeBinaryFromReader(new MContactPackageState(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactPackageState, reader: BinaryReader) {
        return Object.assign(msg, MContactPackageState.deserialize(reader))
    };

}
export interface IContactTraining {
    id?: number;
    modules?: IContactTrainingModule[];
    trainer?: dep_2.IUser;
    /**
     * @lazy
     */
    packageTraining?: dep_3.IPackageTraining;
    /**
     * @lazy
     */
    timespans?: dep_4.ITimespanTraining[];

}
export class ContactTraining implements IContactTraining {

    id?: number;
    modules?: ContactTrainingModule[];
    trainer?: dep_2.User;
    packageTraining?: dep_3.PackageTraining;
    timespans?: dep_4.TimespanTraining[];

    constructor(data?: Partial<IContactTraining>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactTraining extends Message implements ContactTraining {

    constructor(data?: Partial<IContactTraining>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2,21], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("modules" in data && data.modules != undefined) this.modules = data.modules.map(d => new MContactTrainingModule(d));
            if ("trainer" in data && data.trainer != undefined) this.trainer = new dep_2.MUser(data.trainer);
            if ("packageTraining" in data && data.packageTraining != undefined) this.packageTraining = new dep_3.MPackageTraining(data.packageTraining);
            if ("timespans" in data && data.timespans != undefined) this.timespans = data.timespans.map(d => new dep_4.MTimespanTraining(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get modules(): MContactTrainingModule[] {
        return Message.getRepeatedWrapperField(this, MContactTrainingModule, 2);
    }
    set modules(value: MContactTrainingModule[]) {
        Message.setRepeatedWrapperField(this, 2, value);
    }

    get trainer(): dep_2.MUser {
        return Message.getWrapperField(this, dep_2.MUser, 4);
    }
    set trainer(value: dep_2.MUser) {
        Message.setWrapperField(this, 4, value);
    }

    get packageTraining(): dep_3.MPackageTraining {
        return Message.getWrapperField(this, dep_3.MPackageTraining, 20);
    }
    set packageTraining(value: dep_3.MPackageTraining) {
        Message.setWrapperField(this, 20, value);
    }

    get timespans(): dep_4.MTimespanTraining[] {
        return Message.getRepeatedWrapperField(this, dep_4.MTimespanTraining, 21);
    }
    set timespans(value: dep_4.MTimespanTraining[]) {
        Message.setRepeatedWrapperField(this, 21, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactTraining() : {} as ContactTraining;
        if (this.id != undefined) data.id = this.id;
        if (this.modules.length) data.modules = this.modules.map(d => d.toObject(includeInstance));

        if (this.trainer != undefined) data.trainer = this.trainer.toObject(includeInstance);
        if (this.packageTraining != undefined) data.packageTraining = this.packageTraining.toObject(includeInstance);
        if (this.timespans.length) data.timespans = this.timespans.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.modules !== undefined) writer.writeRepeatedMessage(2, this.modules, (i) => i.serialize(writer));
                if (this.trainer !== undefined) writer.writeMessage(4, this.trainer, () => this.trainer.serialize(writer));
                if (this.packageTraining !== undefined) writer.writeMessage(20, this.packageTraining, () => this.packageTraining.serialize(writer));
                if (this.timespans !== undefined) writer.writeRepeatedMessage(21, this.timespans, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactTraining): Uint8Array {
        return (data instanceof Message ? (data as MContactTraining) : new MContactTraining(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactTraining {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactTraining();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    reader.readMessage(message.modules, () => Message.addToRepeatedWrapperField(message, 2, MContactTrainingModule.deserialize(reader), MContactTrainingModule));
                    break;
            case 4:
                    reader.readMessage(message.trainer, () => message.trainer = dep_2.MUser.deserialize(reader));
                    break;
            case 20:
                    reader.readMessage(message.packageTraining, () => message.packageTraining = dep_3.MPackageTraining.deserialize(reader));
                    break;
            case 21:
                    reader.readMessage(message.timespans, () => Message.addToRepeatedWrapperField(message, 21, dep_4.MTimespanTraining.deserialize(reader), dep_4.MTimespanTraining));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactTraining {
        return MContactTraining.deserializeBinaryFromReader(new MContactTraining(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactTraining, reader: BinaryReader) {
        return Object.assign(msg, MContactTraining.deserialize(reader))
    };

}
export interface IContactTrainingModule {
    id?: number;
    sections?: IContactTrainingSection[];
    start?: number;
    end?: number;
    /**
     * @lazy
     */
    packageTrainingModule?: dep_3.IPackageTrainingModule;
    /**
     * @lazy
     */
    timespans?: dep_4.ITimespanTrainingModule[];
    /**
     * @lazy
     */
    comments?: dep_5.IComment[];

}
export class ContactTrainingModule implements IContactTrainingModule {

    id?: number;
    sections?: ContactTrainingSection[];
    start?: number;
    end?: number;
    packageTrainingModule?: dep_3.PackageTrainingModule;
    timespans?: dep_4.TimespanTrainingModule[];
    comments?: dep_5.Comment[];

    constructor(data?: Partial<IContactTrainingModule>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactTrainingModule extends Message implements ContactTrainingModule {

    constructor(data?: Partial<IContactTrainingModule>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2,21,22], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("sections" in data && data.sections != undefined) this.sections = data.sections.map(d => new MContactTrainingSection(d));
            if ("start" in data && data.start != undefined) this.start = data.start;
            if ("end" in data && data.end != undefined) this.end = data.end;
            if ("packageTrainingModule" in data && data.packageTrainingModule != undefined) this.packageTrainingModule = new dep_3.MPackageTrainingModule(data.packageTrainingModule);
            if ("timespans" in data && data.timespans != undefined) this.timespans = data.timespans.map(d => new dep_4.MTimespanTrainingModule(d));
            if ("comments" in data && data.comments != undefined) this.comments = data.comments.map(d => new dep_5.MComment(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get sections(): MContactTrainingSection[] {
        return Message.getRepeatedWrapperField(this, MContactTrainingSection, 2);
    }
    set sections(value: MContactTrainingSection[]) {
        Message.setRepeatedWrapperField(this, 2, value);
    }

    get start(): number {
        return Message.getField(this, 4) as number;
    }
    set start(value: number) {
        Message.setField(this, 4, value);
    }

    get end(): number {
        return Message.getField(this, 5) as number;
    }
    set end(value: number) {
        Message.setField(this, 5, value);
    }

    get packageTrainingModule(): dep_3.MPackageTrainingModule {
        return Message.getWrapperField(this, dep_3.MPackageTrainingModule, 20);
    }
    set packageTrainingModule(value: dep_3.MPackageTrainingModule) {
        Message.setWrapperField(this, 20, value);
    }

    get timespans(): dep_4.MTimespanTrainingModule[] {
        return Message.getRepeatedWrapperField(this, dep_4.MTimespanTrainingModule, 21);
    }
    set timespans(value: dep_4.MTimespanTrainingModule[]) {
        Message.setRepeatedWrapperField(this, 21, value);
    }

    get comments(): dep_5.MComment[] {
        return Message.getRepeatedWrapperField(this, dep_5.MComment, 22);
    }
    set comments(value: dep_5.MComment[]) {
        Message.setRepeatedWrapperField(this, 22, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactTrainingModule() : {} as ContactTrainingModule;
        if (this.id != undefined) data.id = this.id;
        if (this.sections.length) data.sections = this.sections.map(d => d.toObject(includeInstance));

        if (this.start != undefined) data.start = this.start;
        if (this.end != undefined) data.end = this.end;
        if (this.packageTrainingModule != undefined) data.packageTrainingModule = this.packageTrainingModule.toObject(includeInstance);
        if (this.timespans.length) data.timespans = this.timespans.map(d => d.toObject(includeInstance));

        if (this.comments.length) data.comments = this.comments.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.sections !== undefined) writer.writeRepeatedMessage(2, this.sections, (i) => i.serialize(writer));
                if (this.start !== undefined) writer.writeInt64(4, this.start);
                if (this.end !== undefined) writer.writeInt64(5, this.end);
                if (this.packageTrainingModule !== undefined) writer.writeMessage(20, this.packageTrainingModule, () => this.packageTrainingModule.serialize(writer));
                if (this.timespans !== undefined) writer.writeRepeatedMessage(21, this.timespans, (i) => i.serialize(writer));
                if (this.comments !== undefined) writer.writeRepeatedMessage(22, this.comments, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactTrainingModule): Uint8Array {
        return (data instanceof Message ? (data as MContactTrainingModule) : new MContactTrainingModule(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactTrainingModule {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactTrainingModule();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    reader.readMessage(message.sections, () => Message.addToRepeatedWrapperField(message, 2, MContactTrainingSection.deserialize(reader), MContactTrainingSection));
                    break;
            case 4:
                    message.start = reader.readInt64();
                    break;
            case 5:
                    message.end = reader.readInt64();
                    break;
            case 20:
                    reader.readMessage(message.packageTrainingModule, () => message.packageTrainingModule = dep_3.MPackageTrainingModule.deserialize(reader));
                    break;
            case 21:
                    reader.readMessage(message.timespans, () => Message.addToRepeatedWrapperField(message, 21, dep_4.MTimespanTrainingModule.deserialize(reader), dep_4.MTimespanTrainingModule));
                    break;
            case 22:
                    reader.readMessage(message.comments, () => Message.addToRepeatedWrapperField(message, 22, dep_5.MComment.deserialize(reader), dep_5.MComment));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactTrainingModule {
        return MContactTrainingModule.deserializeBinaryFromReader(new MContactTrainingModule(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactTrainingModule, reader: BinaryReader) {
        return Object.assign(msg, MContactTrainingModule.deserialize(reader))
    };

}
export interface IContactTrainingSection {
    id?: number;
    assigns?: IContactTrainingAssign[];
    /**
     * 0 >= 100
     */
    completionPercentage?: number;
    /**
     * @lazy
     */
    packageTrainingSection?: dep_3.IPackageTrainingSection;
    /**
     * @lazy
     */
    timespans?: dep_4.ITimespanTrainingSection[];

}
export class ContactTrainingSection implements IContactTrainingSection {

    id?: number;
    assigns?: ContactTrainingAssign[];
    completionPercentage?: number;
    packageTrainingSection?: dep_3.PackageTrainingSection;
    timespans?: dep_4.TimespanTrainingSection[];

    constructor(data?: Partial<IContactTrainingSection>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactTrainingSection extends Message implements ContactTrainingSection {

    constructor(data?: Partial<IContactTrainingSection>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2,21], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("assigns" in data && data.assigns != undefined) this.assigns = data.assigns.map(d => new MContactTrainingAssign(d));
            if ("completionPercentage" in data && data.completionPercentage != undefined) this.completionPercentage = data.completionPercentage;
            if ("packageTrainingSection" in data && data.packageTrainingSection != undefined) this.packageTrainingSection = new dep_3.MPackageTrainingSection(data.packageTrainingSection);
            if ("timespans" in data && data.timespans != undefined) this.timespans = data.timespans.map(d => new dep_4.MTimespanTrainingSection(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get assigns(): MContactTrainingAssign[] {
        return Message.getRepeatedWrapperField(this, MContactTrainingAssign, 2);
    }
    set assigns(value: MContactTrainingAssign[]) {
        Message.setRepeatedWrapperField(this, 2, value);
    }

    get completionPercentage(): number {
        return Message.getField(this, 3) as number;
    }
    set completionPercentage(value: number) {
        Message.setField(this, 3, value);
    }

    get packageTrainingSection(): dep_3.MPackageTrainingSection {
        return Message.getWrapperField(this, dep_3.MPackageTrainingSection, 20);
    }
    set packageTrainingSection(value: dep_3.MPackageTrainingSection) {
        Message.setWrapperField(this, 20, value);
    }

    get timespans(): dep_4.MTimespanTrainingSection[] {
        return Message.getRepeatedWrapperField(this, dep_4.MTimespanTrainingSection, 21);
    }
    set timespans(value: dep_4.MTimespanTrainingSection[]) {
        Message.setRepeatedWrapperField(this, 21, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactTrainingSection() : {} as ContactTrainingSection;
        if (this.id != undefined) data.id = this.id;
        if (this.assigns.length) data.assigns = this.assigns.map(d => d.toObject(includeInstance));

        if (this.completionPercentage != undefined) data.completionPercentage = this.completionPercentage;
        if (this.packageTrainingSection != undefined) data.packageTrainingSection = this.packageTrainingSection.toObject(includeInstance);
        if (this.timespans.length) data.timespans = this.timespans.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.assigns !== undefined) writer.writeRepeatedMessage(2, this.assigns, (i) => i.serialize(writer));
                if (this.completionPercentage !== undefined) writer.writeInt32(3, this.completionPercentage);
                if (this.packageTrainingSection !== undefined) writer.writeMessage(20, this.packageTrainingSection, () => this.packageTrainingSection.serialize(writer));
                if (this.timespans !== undefined) writer.writeRepeatedMessage(21, this.timespans, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactTrainingSection): Uint8Array {
        return (data instanceof Message ? (data as MContactTrainingSection) : new MContactTrainingSection(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactTrainingSection {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactTrainingSection();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    reader.readMessage(message.assigns, () => Message.addToRepeatedWrapperField(message, 2, MContactTrainingAssign.deserialize(reader), MContactTrainingAssign));
                    break;
            case 3:
                    message.completionPercentage = reader.readInt32();
                    break;
            case 20:
                    reader.readMessage(message.packageTrainingSection, () => message.packageTrainingSection = dep_3.MPackageTrainingSection.deserialize(reader));
                    break;
            case 21:
                    reader.readMessage(message.timespans, () => Message.addToRepeatedWrapperField(message, 21, dep_4.MTimespanTrainingSection.deserialize(reader), dep_4.MTimespanTrainingSection));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactTrainingSection {
        return MContactTrainingSection.deserializeBinaryFromReader(new MContactTrainingSection(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactTrainingSection, reader: BinaryReader) {
        return Object.assign(msg, MContactTrainingSection.deserialize(reader))
    };

}
export interface IContactTrainingAssign {
    id?: number;
    status?: AssignStatus;
    moodleRef?: number;
    submittedAt?: number;
    gradeSubmittedAt?: number;
    needsAttention?: boolean;
    /**
     * @lazy
     */
    packageTrainingAssign?: dep_3.IPackageTrainingAssign;

}
export class ContactTrainingAssign implements IContactTrainingAssign {

    id?: number;
    status?: AssignStatus;
    moodleRef?: number;
    submittedAt?: number;
    gradeSubmittedAt?: number;
    needsAttention?: boolean;
    packageTrainingAssign?: dep_3.PackageTrainingAssign;

    constructor(data?: Partial<IContactTrainingAssign>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactTrainingAssign extends Message implements ContactTrainingAssign {

    constructor(data?: Partial<IContactTrainingAssign>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("status" in data && data.status != undefined) this.status = data.status;
            if ("moodleRef" in data && data.moodleRef != undefined) this.moodleRef = data.moodleRef;
            if ("submittedAt" in data && data.submittedAt != undefined) this.submittedAt = data.submittedAt;
            if ("gradeSubmittedAt" in data && data.gradeSubmittedAt != undefined) this.gradeSubmittedAt = data.gradeSubmittedAt;
            if ("needsAttention" in data && data.needsAttention != undefined) this.needsAttention = data.needsAttention;
            if ("packageTrainingAssign" in data && data.packageTrainingAssign != undefined) this.packageTrainingAssign = new dep_3.MPackageTrainingAssign(data.packageTrainingAssign);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get status(): AssignStatus {
        return Message.getField(this, 3) as AssignStatus;
    }
    set status(value: AssignStatus) {
        Message.setField(this, 3, value);
    }

    get moodleRef(): number {
        return Message.getField(this, 4) as number;
    }
    set moodleRef(value: number) {
        Message.setField(this, 4, value);
    }

    get submittedAt(): number {
        return Message.getField(this, 5) as number;
    }
    set submittedAt(value: number) {
        Message.setField(this, 5, value);
    }

    get gradeSubmittedAt(): number {
        return Message.getField(this, 6) as number;
    }
    set gradeSubmittedAt(value: number) {
        Message.setField(this, 6, value);
    }

    get needsAttention(): boolean {
        return Message.getField(this, 7) as boolean;
    }
    set needsAttention(value: boolean) {
        Message.setField(this, 7, value);
    }

    get packageTrainingAssign(): dep_3.MPackageTrainingAssign {
        return Message.getWrapperField(this, dep_3.MPackageTrainingAssign, 20);
    }
    set packageTrainingAssign(value: dep_3.MPackageTrainingAssign) {
        Message.setWrapperField(this, 20, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactTrainingAssign() : {} as ContactTrainingAssign;
        if (this.id != undefined) data.id = this.id;
        if (this.status != undefined) data.status = this.status;
        if (this.moodleRef != undefined) data.moodleRef = this.moodleRef;
        if (this.submittedAt != undefined) data.submittedAt = this.submittedAt;
        if (this.gradeSubmittedAt != undefined) data.gradeSubmittedAt = this.gradeSubmittedAt;
        if (this.needsAttention != undefined) data.needsAttention = this.needsAttention;
        if (this.packageTrainingAssign != undefined) data.packageTrainingAssign = this.packageTrainingAssign.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.status !== undefined) writer.writeEnum(3, this.status);
                if (this.moodleRef !== undefined) writer.writeInt32(4, this.moodleRef);
                if (this.submittedAt !== undefined) writer.writeInt64(5, this.submittedAt);
                if (this.gradeSubmittedAt !== undefined) writer.writeInt64(6, this.gradeSubmittedAt);
                if (this.needsAttention !== undefined) writer.writeBool(7, this.needsAttention);
                if (this.packageTrainingAssign !== undefined) writer.writeMessage(20, this.packageTrainingAssign, () => this.packageTrainingAssign.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactTrainingAssign): Uint8Array {
        return (data instanceof Message ? (data as MContactTrainingAssign) : new MContactTrainingAssign(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactTrainingAssign {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactTrainingAssign();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 3:
                    message.status = reader.readEnum();
                    break;
            case 4:
                    message.moodleRef = reader.readInt32();
                    break;
            case 5:
                    message.submittedAt = reader.readInt64();
                    break;
            case 6:
                    message.gradeSubmittedAt = reader.readInt64();
                    break;
            case 7:
                    message.needsAttention = reader.readBool();
                    break;
            case 20:
                    reader.readMessage(message.packageTrainingAssign, () => message.packageTrainingAssign = dep_3.MPackageTrainingAssign.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactTrainingAssign {
        return MContactTrainingAssign.deserializeBinaryFromReader(new MContactTrainingAssign(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactTrainingAssign, reader: BinaryReader) {
        return Object.assign(msg, MContactTrainingAssign.deserialize(reader))
    };

}
export enum AssignStatus {
    UNDEFINED_AssignStatus = 0,
    DRAFT = 1,
    SUBMITTED = 2,
    CORRECTED = 3,
}
export interface IContactPackages {
    values?: IContactPackage[];
    count?: number;

}
export class ContactPackages implements IContactPackages {

    values: ContactPackage[];
    count?: number;

    constructor(data?: Partial<IContactPackages>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MContactPackages extends Message implements ContactPackages {

    constructor(data?: Partial<IContactPackages>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MContactPackage(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MContactPackage[] {
        return Message.getRepeatedWrapperField(this, MContactPackage, 1);
    }
    set values(value: MContactPackage[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ContactPackages() : {} as ContactPackages;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IContactPackages): Uint8Array {
        return (data instanceof Message ? (data as MContactPackages) : new MContactPackages(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MContactPackages {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MContactPackages();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MContactPackage.deserialize(reader), MContactPackage));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MContactPackages {
        return MContactPackages.deserializeBinaryFromReader(new MContactPackages(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MContactPackages, reader: BinaryReader) {
        return Object.assign(msg, MContactPackages.deserialize(reader))
    };

}
                        




export default () => {}